import styles from './styles/ListLoading.module.css'
import { IconPaths, KTSVG } from '_metronic/helpers'

export const ListLoading = () => {
  return (
    <div className={styles.loadingContent}>
      <span style={{ fontSize: '48px' }}>
        <KTSVG path={IconPaths.Pill} className='svg-icon-em' ariaHidden />
      </span>
      <div className={styles.dots}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  )
}
